import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { QueryFilters, useBlockedResourcesFull, useBlockedUsersFull } from '../../api';
import { EntityDetails, Timeframe, TopUsersAndResourcesTab } from '../../types';
import TopMetricsChart from '../../../../components/TopMetricsChart/TopMetricsChart';
import { useState } from 'react';

const SEVEN_DAYS_TIMEFRAME: Timeframe = '7';

interface TopBlockChartProps {
    filters: QueryFilters;
    onInvestigationClick: (guid: string, adType: number) => void;
    blockedUsers?: EntityDetails[];
    blockedResources?: EntityDetails[];
    blockedUsersIsLoading?: boolean;
    blockedResourcesIsLoading?: boolean;
}

const TopBlockChart = ({
    filters,
    onInvestigationClick,
    blockedUsers = [],
    blockedResources = [],
    blockedUsersIsLoading = false,
    blockedResourcesIsLoading = false
}: TopBlockChartProps) => {
    const [topBlockedSelectedTab, setTopBlockedSelectedTab] = useState<TopUsersAndResourcesTab>('users');
    const [showMore, setShowMore] = useState(false);

    const { data: blockedUsersFull = [], isLoading: blockedUsersFullIsLoading } = useBlockedUsersFull(
        filters,
        showMore
    );
    const { data: blockedResourcesFull = [], isLoading: blockedResourcesFullIsLoading } = useBlockedResourcesFull(
        filters,
        showMore
    );

    const handleShowMore = () => {
        setShowMore(true);
    };

    const handleInvestigationClick = (guid: string, tabValue: string) => {
        const adType = tabValue === 'users' ? AD_ENTITY_TYPES.USER : AD_ENTITY_TYPES.SERVER;
        onInvestigationClick(guid, adType);
    };

    const timeframe = `last ${filters.timeframe} days`;

    return (
        <TopMetricsChart
            label="Top blocked"
            selectedTab={topBlockedSelectedTab}
            onTabChange={(tab) => setTopBlockedSelectedTab(tab)}
            onInvestigationClick={handleInvestigationClick}
            onShowMore={handleShowMore}
            tabs={[
                {
                    value: 'users',
                    name: 'Users',
                    previewData: blockedUsers,
                    fullData: blockedUsersFull,
                    previewLoading: blockedUsersIsLoading,
                    fullLoading: blockedUsersFullIsLoading,
                    disabled: blockedUsers.length === 0,
                    emptyStateConfig: {
                        title: 'No users yet',
                        description: `No users have been blocked in the last ${timeframe}`
                    }
                },
                {
                    value: 'resources',
                    name: 'Resources',
                    previewData: blockedResources,
                    fullData: blockedResourcesFull,
                    previewLoading: blockedResourcesIsLoading,
                    fullLoading: blockedResourcesFullIsLoading,
                    disabled: blockedResources.length === 0,
                    emptyStateConfig: {
                        title: 'No resources yet',
                        description: `No resources have been blocked in the last ${timeframe}`
                    }
                }
            ]}
        />
    );
};

export default TopBlockChart;
